export default function init_core(IconsView, iconsViewCache) {

IconsView.prototype.onOnload = function (target) {
        if (BEHAV) {
            BEHAV.apply(target);
        }
    }


IconsView.prototype.onUnload = function (target) {
        if (BEHAV) {
            BEHAV.apply(target, 'unload');
        }
    }


IconsView.prototype.timer = function () {
        this.timerLastLoad++;
        this.timerLastLoadfull++;

        if (this.isBusy) {
            this.timerBusy = (this.timerBusy || 0) + 1;
            // Garde-fou de sécurité : si isBusy reste bloqué plus de 120s sans action, réinitialiser
            if (this.timerBusy > 120) {
                this.isBusy = false;
                this.timerBusy = 0;
            }
        } else {
            this.timerBusy = 0;
        }

        if (this.conf.refresh && !this.isLoading && !this.isBusy && this.timerLastLoad >= this.conf.refresh) {
            if (this.dataNodeParent && this.dataNodeParent.load) {
                this.lazyLoad(this.dataNodeParent);
            } else {
                this.load();
            }
            this.timerLastLoad = 0;
        }
    }


IconsView.prototype.init = function () {
        const myself = this;

        if (this.element.data('field')) {
            this.dataField = $('textarea[name="' + this.element.data('field') + '"]');
            if (!this.dataField.val()) this.dataField.val('[]');
            this.dataField.change(() => {
                myself.load();
            });
        }

        if (this.name) {
            this.selectionInput = this.element.parent().find('[name=' + this.name + '_select]');
            if (!this.selectionInput || this.selectionInput.length === 0) {
                this.selectionInput = $('<input type="hidden" name="' + this.name + ((this.element.data('field') == this.name) ? '_select' : '') + '" ' + ((this.uid) ? 'id="' + this.uid + '_select" data-id="' + this.name + '_select"' : '') + ' value="' + (this.value || '') + '" />');
                this.element.before(this.selectionInput);
            }
            this.selectionInputType = this.element.parent().find('[name=' + this.name + '_type]');
            if (!this.selectionInputType || this.selectionInputType.length === 0) {
                this.selectionInputType = $('<input type="hidden" name="' + this.name + '_type" ' + ((this.uid) ? 'id="' + this.uid + '_type" data-id="' + this.name + '_type"' : '') + ' value="' + (this.valueType || '') + '" />');
                this.element.before(this.selectionInputType);
            }
            this.selectionInputLabel = this.element.parent().find('[name=' + this.name + '_label]');
            if (!this.selectionInputLabel || this.selectionInputLabel.length === 0) {
                this.selectionInputLabel = $('<input type="hidden" name="' + this.name + '_label" ' + ((this.uid) ? 'id="' + this.uid + '_label" data-id="' + this.name + '_label"' : '') + ' value="" />');
                this.element.before(this.selectionInputLabel);
            }
        }

        try {
            const parsedPath = JSON.parse(getCookie(this.cookieName));
            this.path = Array.isArray(parsedPath) ? parsedPath : [];
        } catch (e) {
            this.path = [];
        }

        this.loadCache();

        $(this.element).off('contextmenu.iv').on('contextmenu.iv', () => {
            myself.buildGlobalMenu();
            myself.createMenu(myself.globalMenu, myself.element);
            return false;
        });

        if (this.conf.data) {
            this.loadFromData(this.conf);
        }
    };


    IconsView.prototype.destroy = function () {
        if (this.activeViewInstance && typeof this.activeViewInstance.destroy === 'function') {
            try {
                this.activeViewInstance.destroy();
            } catch (e) {}
            this.activeViewInstance = null;
        }
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
        if (this._resizeNamespace) {
            $(window).off(this._resizeNamespace);
        }
        $(this.element).off('.iv');
        if (this.element && this.element.length) {
            this.element.removeData('plugin');
            this.element.removeData('plugin_iconsView');
        }
    };

    IconsView.prototype.toggleCensor = function (forceState) {
        if (forceState !== undefined) {
            this.isCensored = !!forceState;
        } else {
            this.isCensored = !this.isCensored;
        }

        if (this.isCensored) {
            this.element.addClass('iv--censored');
            if (this.containerView) this.containerView.addClass('iv--censored');
        } else {
            this.element.removeClass('iv--censored');
            if (this.containerView) this.containerView.removeClass('iv--censored');
        }

        this.updateCensorButton();
        this.element.trigger('iv:censor', [this.isCensored, this]);
        this.element.trigger('iconsview:censor', [this.isCensored, this]);
        return this.isCensored;
    };

    IconsView.prototype.updateCensorButton = function () {
        const myself = this;
        const $btns = this.element.find('.iv__toolbar-censor, button[data-action="censor"], button[data-action="toggleCensor"]');
        if (!$btns.length) return;

        const isCensored = !!this.isCensored;
        $btns.each(function () {
            const $btn = $(this);
            const act = $btn.data('action') || {};
            const iconShow = act.iconShow || 'fa-eye';
            const iconHide = act.iconHide || 'fa-eye-slash';
            const labelShow = act.labelShow || 'Afficher';
            const labelHide = act.labelHide || 'Masquer';
            const titleShow = act.titleShow || 'Afficher les noms et adresses IP';
            const titleHide = act.titleHide || 'Masquer les noms et adresses IP';

            const useIcon = isCensored ? iconShow : iconHide;
            const useLabel = isCensored ? labelShow : labelHide;
            const useTitle = isCensored ? titleShow : titleHide;

            $btn.toggleClass('active is-censored', isCensored);
            $btn.attr('title', useTitle);
            $btn.html(myself.renderIconImage('small', useIcon) + ' <span class="censor-label">' + useLabel + '</span>');
        });
    };

}
